import { makeStyles, type Theme } from '@material-ui/core/styles';

const drawerWidth = 230;

export default makeStyles((theme: Theme) => ({
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		paddingTop: 64,
		[theme.breakpoints.down('md')]: {
			paddingTop: 24,
		},
	},
	list: {
		'& .MuiListItemText-primary': {
			fontWeight: 500,
		},
	},
	drawerContainer: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
	button: {
		background: theme.palette.primary.light,
		'&:hover': {
			background: theme.palette.primary.dark + '!important',
		},
	},
	selected: {
		borderLeft: '3px solid ' + theme.palette.secondary.main,
		paddingLeft: 13,
		background: 'rgba(17, 178, 162, .1)',
		'& svg': {
			fill: theme.palette.secondary.main,
		},
	},
}));
